import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline group"
          >
            <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              <i className="ri-plant-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-semibold font-heading tracking-wide">
              久久草
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-accent-600 bg-accent-100/70'
                      : isScrolled
                        ? 'text-foreground-700 hover:text-accent-600 hover:bg-accent-50'
                        : 'text-foreground-900 hover:text-accent-600 hover:bg-background-50/30'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:400-888-9999"
              className="flex items-center gap-1.5 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              <span>400-888-9999</span>
            </a>
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-background-50 bg-accent-500 rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即咨询
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-900 hover:bg-background-100 transition-colors duration-300 cursor-pointer"
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-all duration-400 ${
            mobileOpen ? 'max-h-96 pb-4' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col gap-1 bg-background-50/95 backdrop-blur-md rounded-2xl p-3">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 text-sm font-medium rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-accent-600 bg-accent-100/70'
                      : 'text-foreground-700 hover:text-accent-600 hover:bg-accent-50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="border-t border-background-200 mt-1 pt-3 px-4">
              <a
                href="tel:400-888-9999"
                className="flex items-center gap-2 text-sm font-medium text-accent-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}